module.exports = __webpack_public_path__ + "static/img/C4D0006.48e1503.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0006.jpg
// module id = fcD/
// module chunks = 0